import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Asterisk.module.scss'

export const Asterisk = ({ space }) => <span className={classNames(styles.asterisk, { [styles.space]: space })}>*</span>

Asterisk.propTypes = {
  top: PropTypes.bool,
  space: PropTypes.bool,
}
